import fetchAPI from 'utils/fetchAPI';
import { ThunkAction } from 'redux-thunk';

interface ISendHtmlToMailingList {
  channelId: number;
  html: string;
}

interface FormattedMessage {}

function formatMessage(): Promise<FormattedMessage> {
  return new Promise((resolve, reject) => {
    resolve({});
  });
}

export function addSubscriber(
  channelId: number,
  emailAddress: string[]
): ThunkAction<Promise<string>, ReduxState, any> {
  return (dispatch, getState) =>
    new Promise((resolve, reject) => {
      const token = getState().users.token;
      fetchAPI({
        endpoint: `/channels/${channelId}/subscribers`,
        version: '1.2',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          email_address: emailAddress,
        }),
      });
    });
}

export function sendHtmlToMailingList({
  channelId,
  html,
}: ISendHtmlToMailingList): ThunkAction<Promise<string>, ReduxState, any> {
  return (dispatch, getState) =>
    new Promise((resolve, reject) => {
      const token = getState().users.token;

      formatMessage()
        .then(formattedMessage => {
          fetchAPI({
            endpoint: `/channels/${channelId}/send`,
            version: '1.2',
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(formattedMessage),
          })
            .then(res => res.json())
            .then(json => {
              // TODO: implement
            });
        })
        .catch(e => reject(e));
    });
}



// WEBPACK FOOTER //
// ./app/actions/ChannelMailingListActionCreators.ts